const updates = [
  { title: '《暗香》第158话更新', type: '章节更新', desc: '摄政王暗中布局，少年刺客的身份即将揭晓，朝堂风云再起。', time: '10分钟前', accent: true },
  { title: '新作《暖冬》正式上线', type: '新作入库', desc: '南风知意最新治愈系耽美漫画温暖来袭，小镇咖啡馆的爱情故事。', time: '1小时前', accent: false },
  { title: '《夜行》第89话更新', type: '章节更新', desc: '连环案件出现关键线索，法医的秘密即将被刑警队长发觉。', time: '2小时前', accent: false },
  { title: '古风专题新作《烟雨楼》入库', type: '专题更新', desc: '江南烟雨中，两位敌国间谍的禁忌之恋悄然开始。', time: '4小时前', accent: false },
  { title: '《青涩》第203话更新', type: '章节更新', desc: '毕业季来临，篮球少年与图书管理员的感情面临重要抉择。', time: '6小时前', accent: false },
  { title: '科幻分类新增3部热门作品', type: '分类更新', desc: '星际探险、未来机甲、末世生存三大主题新作同步上线。', time: '8小时前', accent: false },
  { title: '《星河》第112话更新', type: '章节更新', desc: '舰队指挥官首次正面接触外星文明，浩瀚宇宙见证跨越物种的深情。', time: '10小时前', accent: false },
  { title: 'ABO专题周活动启动', type: '活动公告', desc: '本周精选20部ABO设定佳作集中推荐，命定之人的故事永不褪色。', time: '14小时前', accent: true },
  { title: '《逆光》第67话更新', type: '章节更新', desc: '广告提案关键时刻，自由摄影师用镜头为创意总监拍下最美的他。', time: '18小时前', accent: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            更新动态
          </h2>
          <p className="text-sm text-foreground-500">耽美漫画网每日内容更新与站点动态速览</p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-px bg-background-300/60"></div>

          <div className="space-y-5">
            {updates.map((item, idx) => (
              <a key={idx} href="#updates" className="flex items-start gap-4 md:gap-5 group">
                <div className={`relative z-10 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                  item.accent ? 'bg-accent-100' : 'bg-secondary-100'
                } group-hover:bg-primary-100 transition-colors`}>
                  <i className={`${
                    item.type === '章节更新' ? 'ri-file-edit-line' :
                    item.type === '新作入库' ? 'ri-bookmark-line' :
                    item.type === '活动公告' ? 'ri-megaphone-line' :
                    'ri-stack-line'
                  } text-sm md:text-base ${item.accent ? 'text-accent-600' : 'text-secondary-600'}`}></i>
                </div>
                <div className="flex-1 min-w-0 pt-0.5">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                      {item.title}
                    </h3>
                    <span className="text-[11px] px-1.5 py-0.5 bg-primary-100/70 text-primary-600 rounded-full whitespace-nowrap">
                      {item.type}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap ml-auto">{item.time}</span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}